import { AnySchema, addMethod, string } from 'yup';

declare module 'yup' {
  interface StringSchema {
    phone: (messageError?: string) => AnySchema;
    alphanumericOnly: (messageError?: string) => StringSchema;
    noLeadWhitespace: (messageError?: string) => StringSchema;
  }
}

// see https://react-hook-form.com/api
export * from 'react-hook-form';
export { yupResolver } from '@hookform/resolvers/yup';

// see https://github.com/jquense/yup
export {
  // AnyObjectSchema,
  object as valSchema,
  array as valArray,
  boolean as valBoolean,
  date as valDate,
  number as valNumber,
  string as valString,
} from 'yup';

export { yupResolver as schemaResolver } from '@hookform/resolvers/yup';

addMethod(string, 'phone', function (messageError = 'Phone number is not valid') {
  const phoneRegExp = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
  return this.matches(phoneRegExp, { message: messageError, excludeEmptyString: true });
});

addMethod(
  string,
  'alphanumericOnly',
  function (messageError = 'Must only contain [a-z], [A-Z], [0-9], underscore, and dashes') {
    const alphanumericOnlyRegExp = /^[a-zA-Z0-9-_]+$/;
    return this.matches(alphanumericOnlyRegExp, { message: messageError, excludeEmptyString: true });
  }
);

addMethod(string, 'noLeadWhitespace', function (messageError = 'Remove leading spaces') {
  const noLeadWhitespaceRegExp = /^[^\s]+.*$/;
  return this.matches(noLeadWhitespaceRegExp, { message: messageError, excludeEmptyString: true });
});

// // Just stubbing in this validator. Don't use this validation until we have an established password policy.
// // Edit to suit policy and remove these comments.
// addMethod(
//   string,
//   'passwordStrength',
//   function (
//     messageError = 'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character'
//   ) {
//     const passwordStrengthRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
//     return this.matches(passwordStrengthRegExp, { message: messageError, excludeEmptyString: true });
//   }
// );
